//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
import { DecryptData } from '../../utils/encryptDecrypt';
//#endregion

export function getRole(params) {
    let _url = url.backendHost + endPoint.role.getRole;
    return axios.get(_url, { params });
}

export function addRole(params) {
    let _url = url.backendHost + endPoint.role.addRole;
    delete params._id
    return axios.post(_url, params);
}

export function updateRole(params) {
    let _url = url.backendHost + endPoint.role.updateRole;
    return axios.put(_url, params);
}

export function deleteRole(params) {
    let _url = url.backendHost + endPoint.role.deleteRole;
    return axios.put(_url, params);
}

export function getRoleDetailsByName(params) {
    let _url = url.backendHost + endPoint.role.getRoleDetailsByName;
    return axios.get(_url, { params });
}

export function getAllRolesName(params) {
    let _url = url.backendHost + endPoint.role.getAllRolesName;
    return axios.get(_url, { params });
}
export function validateUserRole(params) {
    let _url = url.backendHost + endPoint.role.validateUserRole;
    let localData = DecryptData(localStorage.getItem('userType'))
    if(localData){
        return new Promise((resolve,reject) => {
            resolve({userType:[{...JSON.parse(localData)}]})
        })
    }else{
        return axios.get(_url, { params });
    }    
}